import { Log } from './interfaces';

abstract class MessageAdapter {
  abstract critical(message: string): void;

  abstract error(message: string): void;

  abstract warn(message: string): void;

  abstract info(message: string): void;

  abstract showLogs(logs: Log[]): void;
}

export default MessageAdapter;
